export default __webpack_public_path__ + "static/media/x-Cart-p-500.73cac9ba.png";